import {DefaultTheme} from 'styled-components';
import {pxToRem} from '@utils';
import {COLOR_PALETTE} from '@constants';
import {
  occupancy as occupancyDefault,
  occupancyUpdated as occupancyDefaultUpdated,
  occupancyUpdatedB as occupancyDefaultUpdatedB,
} from './defaultTheme';

// TODO: Await usability test results and update these accordingly
const occupancy = {
  ...occupancyDefault,
  background: COLOR_PALETTE.mapiqBlack[600],
  disabled: COLOR_PALETTE.mapiqBlack[400],
};

const occupancyUpdated = {
  ...occupancy,
  ...occupancyDefaultUpdated,
};

const occupancyUpdatedB = {
  ...occupancyUpdated,
  ...occupancyDefaultUpdatedB,
};

export const darkTheme: DefaultTheme = {
  background: {
    white: COLOR_PALETTE.mapiqBlack[900],
    sand: COLOR_PALETTE.black.a100,
    dragAndDropAreaDragging: COLOR_PALETTE.white.a50,
    overlay: COLOR_PALETTE.black.a30,
  },
  brand: COLOR_PALETTE.collaborativeBlue[400],
  disabled: {
    background: COLOR_PALETTE.mapiqBlack[200],
    color: COLOR_PALETTE.mapiqBlack[200],
    colorHighContrast: COLOR_PALETTE.mapiqBlack[400],
  },
  border: {
    color: {
      dragAndDropActive: COLOR_PALETTE.white.a100,
      dragAndDropInactive: COLOR_PALETTE.white.a40,
      sensorStatusUnknwon: COLOR_PALETTE.white.a60,
    },
  },
  boxShadow: {
    secondary: `0px 2px 8px 0px ${COLOR_PALETTE.black.a03}`,
  },
  text: {
    color: {
      body: COLOR_PALETTE.white.a100,
      heading: COLOR_PALETTE.white.a100,
      subtitle: COLOR_PALETTE.mapiqBlack[400],
      error: COLOR_PALETTE.functional.red.default,
    },
    size: {
      xs: pxToRem(10),
      sm: pxToRem(13),
      md: pxToRem(15),
      lg: pxToRem(20),
    },
    weight: {
      regular: 400,
      bold: 600,
    },
  },
  link: {
    default: COLOR_PALETTE.collaborativeBlue[300],
    hover: COLOR_PALETTE.collaborativeBlue[400],
  },
  avatar: {
    border: COLOR_PALETTE.black.a100,
    colors: [
      `linear-gradient(254deg, ${COLOR_PALETTE.collaborativeBlue[500]}, ${COLOR_PALETTE.beige[900]}) no-repeat padding-box`,
      `linear-gradient(254deg, ${COLOR_PALETTE.energizingYellow[500]}, ${COLOR_PALETTE.beige[900]}) no-repeat padding-box`,
      `linear-gradient(254deg, ${COLOR_PALETTE.focusingBrown[500]}, ${COLOR_PALETTE.beige[900]}) no-repeat padding-box`,
      `linear-gradient(254deg, ${COLOR_PALETTE.inspiringOrange[500]}, ${COLOR_PALETTE.beige[900]}) no-repeat padding-box`,
      `linear-gradient(254deg, ${COLOR_PALETTE.creativePink[500]}, ${COLOR_PALETTE.beige[900]}) no-repeat padding-box`,
      `linear-gradient(254deg, ${COLOR_PALETTE.connectingGreen[500]}, ${COLOR_PALETTE.beige[900]}) no-repeat padding-box`,
    ],
    hover: [
      `linear-gradient(254deg, ${COLOR_PALETTE.collaborativeBlue[600]}, ${COLOR_PALETTE.beige[900]}) no-repeat padding-box`,
      `linear-gradient(254deg, ${COLOR_PALETTE.energizingYellow[600]}, ${COLOR_PALETTE.beige[900]}) no-repeat padding-box`,
      `linear-gradient(254deg, ${COLOR_PALETTE.focusingBrown[600]}, ${COLOR_PALETTE.beige[900]}) no-repeat padding-box`,
      `linear-gradient(254deg, ${COLOR_PALETTE.inspiringOrange[600]}, ${COLOR_PALETTE.beige[900]}) no-repeat padding-box`,
      `linear-gradient(254deg, ${COLOR_PALETTE.creativePink[600]}, ${COLOR_PALETTE.beige[900]}) no-repeat padding-box`,
      `linear-gradient(254deg, ${COLOR_PALETTE.connectingGreen[600]}, ${COLOR_PALETTE.beige[900]}) no-repeat padding-box`,
    ],
    unknown: COLOR_PALETTE.mapiqBlack[150],
  },
  button: {
    primary: {
      background: COLOR_PALETTE.mapiqBlack[100],
      border: COLOR_PALETTE.transparent.default,
      color: COLOR_PALETTE.black.a100,
      hover: {
        background: COLOR_PALETTE.white.a100,
        border: COLOR_PALETTE.transparent.default,
        color: COLOR_PALETTE.black.a100,
      },
      disabled: {
        background: COLOR_PALETTE.mapiqBlack[100],
        border: COLOR_PALETTE.transparent.default,
        color: COLOR_PALETTE.mapiqBlack[400],
      },
    },
    secondary: {
      background: COLOR_PALETTE.transparent.default,
      border: COLOR_PALETTE.mapiqBlack[50],
      color: COLOR_PALETTE.mapiqBlack[50],
      hover: {
        background: COLOR_PALETTE.transparent.default,
        border: COLOR_PALETTE.white.a100,
        color: COLOR_PALETTE.white.a100,
      },
      disabled: {
        background: COLOR_PALETTE.transparent.default,
        border: COLOR_PALETTE.mapiqBlack[400],
        color: COLOR_PALETTE.mapiqBlack[400],
      },
    },
    tertiary: {
      background: COLOR_PALETTE.white.a10,
      border: COLOR_PALETTE.transparent.default,
      color: COLOR_PALETTE.mapiqBlack[50],
      hover: {
        background: COLOR_PALETTE.white.a15,
        border: COLOR_PALETTE.transparent.default,
        color: COLOR_PALETTE.white.a100,
      },
      disabled: {
        background: COLOR_PALETTE.mapiqBlack.a03,
        border: COLOR_PALETTE.transparent.default,
        color: COLOR_PALETTE.mapiqBlack[400],
      },
    },
    'primary light': {
      background: COLOR_PALETTE.white.a100,
      border: COLOR_PALETTE.transparent.default,
      color: COLOR_PALETTE.mapiqBlack[800],
      hover: {
        background: COLOR_PALETTE.white.a90,
        border: COLOR_PALETTE.transparent.default,
        color: COLOR_PALETTE.mapiqBlack[800],
      },
      disabled: {
        background: COLOR_PALETTE.mapiqBlack[100],
        border: COLOR_PALETTE.transparent.default,
        color: COLOR_PALETTE.mapiqBlack[400],
      },
    },
    'secondary light': {
      background: COLOR_PALETTE.transparent.default,
      border: COLOR_PALETTE.white.a100,
      color: COLOR_PALETTE.white.a100,
      hover: {
        background: COLOR_PALETTE.transparent.default,
        border: COLOR_PALETTE.white.a90,
        color: COLOR_PALETTE.white.a90,
      },
      disabled: {
        background: COLOR_PALETTE.transparent.default,
        border: COLOR_PALETTE.mapiqBlack[400],
        color: COLOR_PALETTE.mapiqBlack[400],
      },
    },
    'tertiary light': {
      background: COLOR_PALETTE.white.a15,
      border: COLOR_PALETTE.transparent.default,
      color: COLOR_PALETTE.white.a100,
      hover: {
        background: COLOR_PALETTE.white.a20,
        border: COLOR_PALETTE.transparent.default,
        color: COLOR_PALETTE.white.a100,
      },
      disabled: {
        background: COLOR_PALETTE.mapiqBlack.a03,
        border: COLOR_PALETTE.transparent.default,
        color: COLOR_PALETTE.mapiqBlack[400],
      },
    },
    'primary destructive': {
      background: COLOR_PALETTE.functional.red.default,
      border: COLOR_PALETTE.transparent.default,
      color: COLOR_PALETTE.white.a100,
      hover: {
        background: COLOR_PALETTE.functional.red.hover,
        border: COLOR_PALETTE.transparent.default,
        color: COLOR_PALETTE.white.a100,
      },
      disabled: {
        background: COLOR_PALETTE.mapiqBlack[100],
        border: COLOR_PALETTE.transparent.default,
        color: COLOR_PALETTE.mapiqBlack[400],
      },
    },
    'secondary destructive': {
      background: COLOR_PALETTE.white.a10,
      border: COLOR_PALETTE.transparent.default,
      color: COLOR_PALETTE.functional.red.default,
      hover: {
        background: COLOR_PALETTE.white.a15,
        border: COLOR_PALETTE.transparent.default,
        color: COLOR_PALETTE.functional.red.hover,
      },
      disabled: {
        background: COLOR_PALETTE.mapiqBlack.a03,
        border: COLOR_PALETTE.transparent.default,
        color: COLOR_PALETTE.mapiqBlack[400],
      },
    },
    text: {
      background: COLOR_PALETTE.transparent.default,
      border: COLOR_PALETTE.transparent.default,
      color: COLOR_PALETTE.collaborativeBlue[500],
      hover: {
        background: COLOR_PALETTE.transparent.default,
        border: COLOR_PALETTE.transparent.default,
        color: COLOR_PALETTE.collaborativeBlue[700],
      },
      disabled: {
        background: COLOR_PALETTE.transparent.default,
        border: COLOR_PALETTE.transparent.default,
        color: COLOR_PALETTE.mapiqBlack[400],
      },
    },
  },
  card: {
    beige200: {
      background: COLOR_PALETTE.beige[200],
      border: COLOR_PALETTE.beige[200],
      color: COLOR_PALETTE.mapiqBlack[800],
      hover: {
        background: COLOR_PALETTE.beige[300],
        border: COLOR_PALETTE.beige[300],
        color: COLOR_PALETTE.mapiqBlack[800],
      },
    },
    beige500: {
      background: COLOR_PALETTE.beige[500],
      border: COLOR_PALETTE.beige[500],
      color: COLOR_PALETTE.mapiqBlack[800],
      hover: {
        background: COLOR_PALETTE.focusingBrown[200],
        border: COLOR_PALETTE.focusingBrown[200],
        color: COLOR_PALETTE.mapiqBlack[800],
      },
    },
    connectingGreen: {
      background: COLOR_PALETTE.connectingGreen[500],
      border: COLOR_PALETTE.connectingGreen[500],
      color: COLOR_PALETTE.white.a100,
      hover: {
        background: COLOR_PALETTE.connectingGreen[600],
        border: COLOR_PALETTE.connectingGreen[600],
        color: COLOR_PALETTE.white.a100,
      },
    },
    energizingYellow: {
      background: COLOR_PALETTE.energizingYellow[500],
      border: COLOR_PALETTE.energizingYellow[500],
      color: COLOR_PALETTE.mapiqBlack[800],
      hover: {
        background: COLOR_PALETTE.energizingYellow[550],
        border: COLOR_PALETTE.energizingYellow[550],
        color: COLOR_PALETTE.mapiqBlack[800],
      },
    },
    focusingBrown: {
      background: COLOR_PALETTE.focusingBrown[100],
      border: COLOR_PALETTE.focusingBrown[100],
      color: COLOR_PALETTE.white.a100,
      hover: {
        background: COLOR_PALETTE.focusingBrown[200],
        border: COLOR_PALETTE.focusingBrown[200],
        color: COLOR_PALETTE.white.a100,
      },
    },
    safeMauve: {
      background: COLOR_PALETTE.safeMauve[500],
      border: COLOR_PALETTE.safeMauve[500],
      color: COLOR_PALETTE.white.a100,
      hover: {
        background: COLOR_PALETTE.safeMauve[600],
        border: COLOR_PALETTE.safeMauve[600],
        color: COLOR_PALETTE.white.a100,
      },
    },
    transparent: {
      background: COLOR_PALETTE.transparent.default,
      border: COLOR_PALETTE.white.a10,
      color: COLOR_PALETTE.white.a100,
      hover: {
        background: COLOR_PALETTE.white.a10,
        border: COLOR_PALETTE.white.a10,
        color: COLOR_PALETTE.white.a100,
      },
    },
    white: {
      background: COLOR_PALETTE.mapiqBlack[900],
      border: COLOR_PALETTE.transparent.default,
      color: COLOR_PALETTE.mapiqBlack[50],
      hover: {
        background: COLOR_PALETTE.mapiqBlack[800],
        border: COLOR_PALETTE.transparent.default,
        color: COLOR_PALETTE.mapiqBlack[50],
      },
    },
    opaque: {
      background: COLOR_PALETTE.white.a10,
      border: COLOR_PALETTE.transparent.default,
      color: COLOR_PALETTE.white.a100,
      hover: {
        background: COLOR_PALETTE.white.a10,
        border: COLOR_PALETTE.transparent.default,
        color: COLOR_PALETTE.white.a100,
      },
    },
    red: {
      background: COLOR_PALETTE.inspiringOrange[600],
      border: COLOR_PALETTE.transparent.default,
      color: COLOR_PALETTE.white.a100,
      hover: {
        background: COLOR_PALETTE.inspiringOrange[700],
        border: COLOR_PALETTE.transparent.default,
        color: COLOR_PALETTE.white.a100,
      },
    },
    mapiqBlack: {
      background: COLOR_PALETTE.mapiqBlack[75],
      border: COLOR_PALETTE.mapiqBlack[75],
      color: COLOR_PALETTE.mapiqBlack[800],
      hover: {
        background: COLOR_PALETTE.mapiqBlack[150],
        border: COLOR_PALETTE.mapiqBlack[150],
        color: COLOR_PALETTE.mapiqBlack[800],
      },
    },
  },
  divider: {
    white: COLOR_PALETTE.black.a100,
    grey: COLOR_PALETTE.black.a100,
    sand: COLOR_PALETTE.black.a100,
  },
  occupancy,
  occupancyUpdated,
  occupancyUpdatedB,
  input: {
    background: COLOR_PALETTE.black.a100,
    border: {
      default: COLOR_PALETTE.mapiqBlack[50],
      checked: COLOR_PALETTE.mapiqBlack[50],
      transparent: COLOR_PALETTE.transparent.default,
    },
    color: COLOR_PALETTE.white.a100,
    placeholder: COLOR_PALETTE.mapiqBlack[50],
    hover: {
      background: COLOR_PALETTE.mapiqBlack[900],
      border: COLOR_PALETTE.mapiqBlack[50],
      color: COLOR_PALETTE.mapiqBlack[50],
    },
    invalid: {
      background: COLOR_PALETTE.mapiqBlack[50],
      border: COLOR_PALETTE.functional.red.default,
      color: COLOR_PALETTE.mapiqBlack[800],
    },
    select: {
      background: COLOR_PALETTE.black.a100,
    },
    toggle: {
      background: COLOR_PALETTE.mapiqBlack[400],
      checked: COLOR_PALETTE.functional.green.default,
      handle: COLOR_PALETTE.black.a100,
    },
    option: {
      background: COLOR_PALETTE.black.a100,
      color: COLOR_PALETTE.white.a100,
      hover: {
        background: COLOR_PALETTE.mapiqBlack[700],
        color: COLOR_PALETTE.white.a100,
      },
      selected: {
        background: COLOR_PALETTE.mapiqBlack[50],
        color: COLOR_PALETTE.mapiqBlack[900],
      },
    },
  },
  label: {
    beige: {
      background: COLOR_PALETTE.beige[100],
      color: COLOR_PALETTE.mapiqBlack[800],
      hover: {
        background: COLOR_PALETTE.beige[200],
        color: COLOR_PALETTE.mapiqBlack[800],
      },
    },
    connectingGreen: {
      background: COLOR_PALETTE.functional.green.default,
      color: COLOR_PALETTE.white.a100,
      hover: {
        background: COLOR_PALETTE.functional.green.hover,
        color: COLOR_PALETTE.white.a100,
      },
    },
  },
  toast: {
    success: {
      background: COLOR_PALETTE.white.a100,
      color: COLOR_PALETTE.black.a100,
    },
    warning: {
      background: COLOR_PALETTE.functional.orange.default,
      color: COLOR_PALETTE.white.a100,
    },
    error: {
      background: COLOR_PALETTE.functional.red.default,
      color: COLOR_PALETTE.white.a100,
    },
  },
  icon: {
    active: COLOR_PALETTE.white.a100,
    inactive: COLOR_PALETTE.mapiqBlack[400],
    duotone: {
      color: COLOR_PALETTE.black.a100,
    },
  },
  validation: {
    iconColor: COLOR_PALETTE.white.a100,
    error: COLOR_PALETTE.functional.red.default,
    success: COLOR_PALETTE.functional.green.default,
    unknown: COLOR_PALETTE.mapiqBlack[500],
    warning: COLOR_PALETTE.functional.orange.default,
    notification: COLOR_PALETTE.collaborativeBlue[500],
    card: {
      error: {
        iconBackground: COLOR_PALETTE.functional.red.default,
        background: COLOR_PALETTE.functional.red.default,
      },
      warning: {
        iconBackground: COLOR_PALETTE.functional.orange.default,
        background: COLOR_PALETTE.functional.orange.default,
      },
    },
  },
  mapiqLogo: {
    light: COLOR_PALETTE.white.a100,
    dark: COLOR_PALETTE.mapiqBlack[800],
  },

  gradientBars: {
    temperature: {
      colors: [
        COLOR_PALETTE.inspiringOrange[500],
        COLOR_PALETTE.inspiringOrange[300],
        COLOR_PALETTE.inspiringOrange[200],
        COLOR_PALETTE.collaborativeBlue[200],
        COLOR_PALETTE.collaborativeBlue[300],
        COLOR_PALETTE.collaborativeBlue[500],
      ],
    },
    blinds: {
      colors: [
        COLOR_PALETTE.energizingYellow[500],
        COLOR_PALETTE.energizingYellow[300],
        COLOR_PALETTE.energizingYellow[200],
        COLOR_PALETTE.safeMauve[200],
        COLOR_PALETTE.safeMauve[300],
        COLOR_PALETTE.safeMauve[500],
      ],
    },
  },
};
